import React from 'react';
import { Link } from 'react-router-dom';

const NemwelBio = () => (
  <div className="NemwelBio">
    <p>
      Hello! I am Nemwel. I am an innovative Full stack web developer with
      over 2 years of professional experience in JavaScript(React) and Ruby(Ruby on
      Rails). I am passionate about building applications’ interfaces and the
      optimization that comes with them. Not limited to this, I also develop
      backend API(S) to be consumed by multiple front ends. I take pride in doing
      what I do as I do it wholeheartedly to the best of my abilities with the
      accepted industry standards in mind.

      Away from my computer, I enjoy reading about new technology concepts, working
      on my side projects and attending and participating in tech events.
    </p>
    <div className="NemwelBioDetails">
      <p>
        <span>
          <i className="fa fa-flag" aria-hidden="true" />
          Nationality:
        </span>
        {' '}
        Kenyan
      </p>
      <p>
        <span>
          <i className="fa fa-map-marker" aria-hidden="true" />
          Address:
        </span>
        {' '}
        Nairobi
      </p>
      <p>
        <span>
          <i className="fa fa-phone" aria-hidden="true" />
          Phone:
        </span>
        {' '}
        +254727475518
      </p>
      <p>
        <span>
          <i className="fa fa-briefcase" aria-hidden="true" />
          Freelance:
        </span>
        {' '}
        Available
      </p>
      <p>
        <span>
          <i className="fa fa-envelope-o" aria-hidden="true" />
          Email:
        </span>
        {' '}
        <a href="mailto:nemwelnyandoro20@gmail.com">mail me</a>
      </p>
    </div>
    <Link className="downloadcv" to="/resume">Resume</Link>
  </div>
);

export default NemwelBio;
